import { useState, useEffect, useMemo, FC } from "react";
import { Loading, NoContent } from "components";
import { useForm, FormProvider } from "react-hook-form";
import { useRouter } from "next/router";
import { FaqParentItem, Search } from ".";
import { ApiService } from "services/client";

const apiService = new ApiService("fa", true);

const combineData = (arrayOfObj) => {
  const result = {};
  arrayOfObj?.forEach?.((obj, i) => {
    result[obj?.Categories?.value || i] = [];
    obj?.Questions?.value?.forEach?.((item, j) => {
      result[obj?.Categories?.value || i]?.push?.({
        question: item || "",
        answer: obj.Answers?.value?.[j] || "",
        id: `${i}${j}`,
      });
    });
  });

  return result;
};

interface IProps {
  faqTagTree?: string;
  data?: any;
  showSearch?: boolean;
}

const FaqComponent: FC<IProps> = ({
  data = null,
  faqTagTree = null,
  showSearch = true,
}) => {
  const router = useRouter();
  const questions = data?.questions || [];
  const methods = useForm();
  const [listData, setListData] = useState({});
  const [loading, setLoading] = useState(false);
  const query = methods.watch("query");
  const filteredData = useMemo(() => {
    const clonedList = {};
    if (!query) return listData;

    for (const key in listData) {
      if (key.includes(query)) {
        clonedList[key] = listData[key];
        continue;
      }
      listData?.[key]?.forEach?.((item) => {
        if (
          item?.question?.includes?.(query) ||
          item?.answer?.includes?.(query)
        ) {
          clonedList[key] = Array.isArray(clonedList?.[key])
            ? clonedList?.[key]?.concat(item)
            : [item];
        }
      });
    }
    return clonedList;
  }, [listData, query]);

  useEffect(() => {
    const fetchData = async () => {
      if (faqTagTree) {
        try {
          setLoading(true);
          const res = await apiService.getFAQByTagTree(faqTagTree);
          setListData(combineData(res));
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      } else {
        setListData(combineData(questions));
      }
    };
    fetchData();
  }, [router, faqTagTree]);

  return (
    <div className="tw-pb-[50px] tw-px-4 md:tw-px-0">
      {showSearch && (
        <FormProvider {...methods}>
          <Search />
        </FormProvider>
      )}
      {/* <h1 className='tw-text-[#344456] tw-font-bold tw-text-base tw-pr-2.5 tw-border-solid tw-border-r-4 tw-border-y-0 tw-border-l-0 tw-border-[#007FAC] tw-mt-[50px]'>{title}</h1> */}
      {loading ? (
        <div className="tw-min-h-[200px] tw-flex tw-items-center tw-justify-center loading">
          <Loading />
        </div>
      ) : (
        <div className="tw-mt-[30px]">
          {Object.entries(filteredData).length > 0 ? (
            Object.entries(filteredData)?.map?.(([key, item], i) => (
              <FaqParentItem index={i} key={key} parent={item} title={key} />
            ))
          ) : (
            <NoContent />
          )}
        </div>
      )}
    </div>
  );
};

export default FaqComponent;
